/* eslint-disable import/prefer-default-export */
import { AppThunk } from '../../ThunkTypes';
import { setCurrentCustomer } from '../slice/customerslice';
import CustomerItem, {
  CustomerType,
} from '../../../models/helperTypes/CustomerItem';

/**
 * Updates current customer information in the slice.
 *
 * @param customer - New customer data
 */
export const setCustomer =
  (customer: CustomerItem): AppThunk =>
  (dispatch): void => {
    dispatch(setCurrentCustomer(customer));
  };

/**
 * Updates current customer type
 * @param type New customer type
 */
export const setCustomerType =
  (type: CustomerType): AppThunk =>
  (dispatch, getState): void => {
    const { currentCustomer } = getState().customer;

    dispatch(
      setCurrentCustomer({
        ...currentCustomer,
        type,
      }),
    );
  };
